import { useEffect, useRef, useState } from "react"
import "./App.css"
import { Carousel } from "./Carousel"
import { AlbumFoto, Foto, maakDownloadStrategy, maakGalerijDownloadStrategy } from "./downloadStrategies/downloadStrategies"
import { Galerij } from "./Galerij"
import { Icon } from "./icons/Icon"

const FOTOS_PER_PAGINA = 5

const startDownloaden = (blobUrl: string, filename: string) => {
    var link = document.createElement("a")
    link.href = blobUrl
    link.download = filename
    link.click()
}

function App() {
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [alleFotoUrls, setAlleFotoUrls] = useState<(Foto | undefined)[]>([])
    const [huidigeFoto, setHuidigeFoto] = useState<Foto | undefined>(undefined)

    const [alleGalerijFotoUrls, setGalerijAlleFotoUrls] = useState<(AlbumFoto | undefined)[]>([])
    const [gallerijGrootte, setGallerijGrootte] = useState<number | undefined>(undefined)
    const gallerijLaatsteFoto = useRef<number | undefined>(undefined)
    const [kanNieuwePaginaLaden, setKanNieuwePaginaLaden] = useState(false)
    const [laadMeerGallerijFotos, setLaadMeerGallerijFotos] = useState(() => () => {})

    const isGalerij = new URLSearchParams(window.location.search).get("view") === "gallery"

    useEffect(() => {
        setIsLoading(true)

        if (isGalerij) {
            const downloadStrategy = maakGalerijDownloadStrategy()

            // Deze functie download de pagina die na de huidige laatste index komt. Hij blijft dit doen tot alle beschikbare paginas geladen zijn
            const downloadVolgendePagina = () => {
                setKanNieuwePaginaLaden(false)
                const start = gallerijLaatsteFoto.current ?? 0
                downloadStrategy
                    .downloadFotos(start, start + FOTOS_PER_PAGINA)
                    .then((fotoPromises) => {
                        let nieuweFotos = fotoPromises.map(() => undefined)
                        setGalerijAlleFotoUrls((bestaandeFotos) => [...bestaandeFotos, ...nieuweFotos])
                        return Promise.all(
                            fotoPromises.map((promise, index) =>
                                promise
                                    .then((foto) => {
                                        setGalerijAlleFotoUrls((alleFotoUrls) => {
                                            const nieuweUrls = [...alleFotoUrls]
                                            nieuweUrls[start + index] = foto
                                            return nieuweUrls
                                        })
                                    })
                                    .catch((e) => console.error(e))
                            )
                        )
                    })
                    .catch(setErrorMessage)
                    .finally(() => {
                        gallerijLaatsteFoto.current = start + FOTOS_PER_PAGINA
                        setKanNieuwePaginaLaden(true)
                    })
                    .then(() => downloadStrategy.getAantalFotos())
                    .then((aantalFotos) => {
                        if ((gallerijLaatsteFoto.current ?? 0) < aantalFotos) {
                            downloadVolgendePagina()
                        }
                    })
            }

            downloadStrategy
                .getAantalFotos()
                .then((aantalFotos) => setGallerijGrootte(aantalFotos))
                .then(() => downloadVolgendePagina())
                .catch(setErrorMessage)
                .finally(() => {
                    setLaadMeerGallerijFotos(() => () => downloadVolgendePagina())
                    setIsLoading(false)
                })
        } else {
            maakDownloadStrategy()
                .bepaalFotos()
                .then((fotoPromises) => {
                    setAlleFotoUrls(fotoPromises.map(() => undefined))
                    if (fotoPromises.length === 0) {
                        setErrorMessage("Oeps, deze foto is niet meer beschikbaar!")
                    }
                    fotoPromises.map((promise, index) => {
                        promise
                            .then((foto) => {
                                setAlleFotoUrls((alleFotoUrls) => {
                                    const nieuweUrls = [...alleFotoUrls]
                                    nieuweUrls[index] = foto

                                    return nieuweUrls
                                })
                            })
                            .catch((e) => console.error(e))
                    })
                })
                .catch(setErrorMessage)
                .finally(() => setIsLoading(false))
        }
    }, [])

    return (
        <div id="app">
            <header>
                <div className="logo">
                    <a href="https://jjfotobooth.nl">
                        <img src="logo.jpg"></img>
                    </a>
                </div>

                <div style={{ marginLeft: "auto" }}>
                    {huidigeFoto && (
                        <button onClick={() => startDownloaden(huidigeFoto.url, "photobooth.jpg")}>
                            <Icon icon="download" />
                        </button>
                    )}
                </div>
            </header>
            <main>
                {isLoading ? (
                    <div className="laad-icoon">
                        <Icon icon="spinner" />
                    </div>
                ) : (
                    <>
                        {errorMessage ? (
                            <h1>{errorMessage}</h1>
                        ) : isGalerij ? (
                            <>
                                <Galerij
                                    fotos={alleGalerijFotoUrls}
                                    isFotosAanHetLaden={!kanNieuwePaginaLaden}
                                    laadMeerFotos={
                                        gallerijGrootte && gallerijLaatsteFoto.current && (gallerijLaatsteFoto.current ?? 0) < (gallerijGrootte ?? 0)
                                            ? laadMeerGallerijFotos
                                            : undefined
                                    }
                                />
                            </>
                        ) : (
                            <Carousel fotos={alleFotoUrls} onHuidigeFotoVeranderd={setHuidigeFoto} />
                        )}
                    </>
                )}
            </main>
        </div>
    )
}

export default App
